import { render } from "./PublicatiesView.vue?vue&type=template&id=2b9afdf8"
import script from "./PublicatiesView.vue?vue&type=script&lang=js"
export * from "./PublicatiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__